import * as actionTypes from './actionTypes';
import axiosInstance from '../../axios-instance';
import { authSuccess } from '@src/store/actions/auth';

export const forgotPasswordStart = () => {
  return {
    type: actionTypes.FORGOT_PASSWORD_START
  };
};

export const forgotPasswordSuccess = () => {
  return {
    type: actionTypes.FORGOT_PASSWORD_SUCCESS
  };
};

export const forgotPasswordFail = error => {
  return {
    type: actionTypes.FORGOT_PASSWORD_FAIL,
    error: error
  };
};

export const resetForgotPasswordState = () => {
  return {
    type: actionTypes.FORGOT_PASSWORD_RESET
  };
};

export const forgotPasswordRequest = email => {
  return dispatch => {
    dispatch(forgotPasswordStart());
    axiosInstance()
      .post('/users/forgot-password.json', { email: email })
      .then(response => {
        dispatch(forgotPasswordSuccess());
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(forgotPasswordFail(err.response.data.message));
        } else {
          dispatch(forgotPasswordFail('Problem with connection to API.'));
        }
      });
  };
};

// Reset Password
export const forgotPasswordHashCheck = email => {
  return {
    type: actionTypes.FORGOT_PASSWORD_HASH_SUCCESS,
    email: email
  };
};
export const forgotPasswordResetPassword = (hash, postData) => {
  return dispatch => {
    dispatch(forgotPasswordStart());
    axiosInstance()
      .post('/reset-password/' + hash + '.json', postData)
      .then(response => {
        localStorage.setItem('auth', JSON.stringify(response.data));
        localStorage.setItem('validTo', Math.floor(Date.now() / 1000) + 14400);
        dispatch(authSuccess(response.data));
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(forgotPasswordFail(err.response.data.message));
        } else {
          dispatch(forgotPasswordFail('Problem with connection to API.'));
        }
      });
  };
};

export const forgotPasswordCheckHash = hash => {
  return dispatch => {
    dispatch(forgotPasswordStart());
    axiosInstance()
      .get('/reset-password/' + hash + '.json')
      .then(response => {
        dispatch(forgotPasswordHashCheck(response.data.email));
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(forgotPasswordFail(err.response.data.message));
        } else {
          dispatch(forgotPasswordFail('Problem with connection to API.'));
        }
      });
  };
};
